import {
  FormControl,
  FormLabel,
  Grid,
  makeStyles,
  MenuItem,
  Typography,
} from '@material-ui/core';
import { Field, FieldProps } from 'formik';
import React from 'react';
import { useSubstate } from 'use-substate';

import useCustomerSelectable from 'core/hooks/useCustomerSelectable';
import useLocations from 'core/hooks/useLocations';
import useProducts from 'core/hooks/useProducts';
import { selectUniqueProductSizes } from 'core/Store/products/selectors';
import {
  Form,
  FormSubmitHandler,
  InputField,
  SubmitButton,
} from 'Elements/Form';
import DayrangePicker from 'Elements/Form/Dayrange/Dayrange';
import ResetButton from 'Elements/Form/ResetButton';
import SliderField from 'Elements/Form/Slider/Slider';
import SearchProducts from 'Elements/Search/SearchProducts';
import SearchPane from 'Elements/SearchPane/SearchPane';

import schema, { initialValues, Schema } from './schema';

const useStyles = makeStyles(theme => ({
  checkbox: {
    padding: '2px 9px'
  },
  formLabel: {
    margin: '10px 0px 10px 15px',
    fontSize: '12px'
  },
  button: {
    marginLeft: theme.spacing(1)
  }
}));

type Props = {
  onSubmit: FormSubmitHandler<Schema>;
};

export default function FilterSurfaces({ onSubmit }: Props) {
  const classes = useStyles();
  const locations = useLocations();
  const customers = useCustomerSelectable();

  useProducts();
  const [sizes] = useSubstate(selectUniqueProductSizes);

  return (
    <SearchPane>
      <Typography variant="h6">Suodattimet</Typography>
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={schema}
      >
        <InputField
          name="size"
          fullWidth
          select
          variant="outlined"
          helperText="Valitse"
          margin="normal"
          InputLabelProps={{
            shrink: true
          }}
        >
          {sizes.map(size => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </InputField>
        <Field name="product_id">
          {({ field }: FieldProps<number>) => (
            <InputField
              fullWidth
              margin="normal"
              variant="outlined"
              name={field.name}
              component={SearchProducts}
              InputLabelProps={{
                shrink: true
              }}
            />
          )}
        </Field>
        <FormControl component="fieldset" margin="normal" fullWidth>
          <FormLabel component="legend" className={classes.formLabel}>
            Urasyvyys
          </FormLabel>
          <SliderField name="track_depth" min={1} max={20} step={1} />
        </FormControl>
        <InputField
          name="owner_id"
          select
          fullWidth
          variant="outlined"
          placeholder="Valitse"
          margin="normal"
          InputLabelProps={{
            shrink: true
          }}
        >
          {customers
            .sort((a, b) => a.company.localeCompare(b.company))
            .map(customer => (
              <MenuItem key={customer.id} value={customer.id}>
                {customer.company}
              </MenuItem>
            ))}
        </InputField>
        <InputField
          name="customer_id"
          select
          fullWidth
          variant="outlined"
          placeholder="Valitse"
          helperText="Yritys, jolle rengas on varattu"
          margin="normal"
          InputLabelProps={{
            shrink: true
          }}
        >
          {customers
            .sort((a, b) => a.company.localeCompare(b.company))
            .map(customer => (
              <MenuItem key={customer.id} value={customer.id}>
                {customer.company}
              </MenuItem>
            ))}
        </InputField>
        <InputField
          name="location_id"
          select
          fullWidth
          variant="outlined"
          placeholder="Valitse"
          margin="normal"
          InputLabelProps={{
            shrink: true
          }}
        >
          {locations.map(location => (
            <MenuItem key={location.id} value={location.id}>
              {location.name}
            </MenuItem>
          ))}
        </InputField>

        <FormControl fullWidth>
          <DayrangePicker name="range" />
        </FormControl>
        <Grid container justify="flex-end">
          <ResetButton className={classes.button} variant="contained">
            Nollaa
          </ResetButton>
          <SubmitButton
            className={classes.button}
            variant="contained"
            color="secondary"
          >
            Suodata
          </SubmitButton>
        </Grid>
      </Form>
    </SearchPane>
  );
}
